import script from "./WoononProductMobile.vue?vue&type=script&lang=ts&setup=true"
export * from "./WoononProductMobile.vue?vue&type=script&lang=ts&setup=true"

import "./WoononProductMobile.vue?vue&type=style&index=0&id=5c5f4837&lang=less&scoped=true"

import exportComponent from "/var/build/production/buyers-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c5f4837"]])

export default __exports__